import '@babel/polyfill' // NOTE - REQUIRED ON EVERY PAGE
import * as React from 'react'
import withRedux from 'next-redux-wrapper'
import SiteWrapper from '../client/components/SiteWrapper'
import {makeStore} from '../client/redux'
import CMSDrivenPage from 'pages/CMSDrivenPage/CMSDrivenPage'
import {LearnvestApi} from '../client/api/learnvest'
import {checkSubscriptionCookies} from 'store/actions/site'
import {handleApiUnavailableError} from '../client/utils/errors'
import {TermsOfUseContent} from '../client/data/pages/termsofuse'

class TermsOfUse extends React.Component {
  static async getInitialProps ({req, store, query}) {
    try {
      const learnvestApi = new LearnvestApi(query.ajax)
      checkSubscriptionCookies(req, store)
      await learnvestApi.cms(store)
      return {}
    } catch (e) {
      return handleApiUnavailableError(e)
    }
  }

  render () {
    return (
      <SiteWrapper includeNewsletterPromo={false}>
        <CMSDrivenPage title={'Terms of Use'} pageData={<TermsOfUseContent />} canonicalPath={'/termsofuse'} />
      </SiteWrapper>
    )
  }
}

export default withRedux(makeStore)(TermsOfUse)



// WEBPACK FOOTER //
// ./pages/termsofuse.js